import React, {SVGProps} from 'react';
import {DELETE_IMAGE} from '../../../constants/images.constants';

const SvgDelete = (props: SVGProps<SVGSVGElement>) => {
	return <img src={DELETE_IMAGE} style={{ width: '90%', height: '90%' }} />;
};

export default SvgDelete;
